import Cookies from 'js-cookie';
import { getDomain } from 'tldts';

export const setCookie = (name: string, value: string, expires: Date | number | undefined, domain: string) => {
  Cookies.set(name, value, { expires, domain });
};

export const getCookie = (name: string) => {
  return Cookies.get(name);
};

export const removeCookie = (name: string) => {
  Cookies.remove(name);
};

const getDomainUrl = () => {
  return getDomain(window.location.href) || "";
};

// utils/cookies.ts
export const getCookieName = (redirectUrl: string) => {
  try {
    const url = new URL(redirectUrl);
    const hostname = url.hostname.replace(/\./g, '_'); // Replace dots with underscores
    return `token_${hostname}`;
  } catch (error) {
    console.error('Invalid URL provided to getCookieName:', error);
    return 'token_default';
  }
};

export const clearAllCookies = () => {
  const allCookies = Cookies.get();

  for (const cookieName in allCookies) {
    const domain = getDomainUrl();
    if (Object.prototype.hasOwnProperty.call(allCookies, cookieName)) {
      Cookies.remove(cookieName as string, { domain });
    }
  }
};

